export class Event {

    private id: number;
    private code: string;
    private payerCountry: string;
    private currencyCode: string;
    private cpaKey: string;
    private discountProductGroup: string;
    private measurementPeriod: number | null;
    private discountPeriod: number | null;
    private thresholdType: string | null;
    private discountTiersAndValues: string | null;
    private rampUpPeriod: number | null;
    private rampUpStartDate: number | null;
    private rampUpEndDate: number | null;
    private initialDiscountPercent: number | null;
    private initialDiscountPeriod: number | null;
    private currentDiscountPercent: number | null;
    private topDiscountPercent: number | null;
    private revenueCount: number | null;
    private progressCount: number | null;
    private gapToCurrentLevel: number | null;
    private gapToNextLevel: number | null;
    private nextDiscountStartDate: number | null;
    private nextDiscountPercent: number | null;
    private flagProcessed: string;
    private flagProcessedMarketo: string;
    private eventMonth: string;
    private dateInserted: number;
    private dtimeInserted: number;
    private dtimeUpdated: number;

    constructor(raw: any) {
        if (raw) {
            this.setId(raw.ID);
            this.setCode(raw.CODE);
            this.setPayerCountry(raw.PAYER_COUNTRY);
            this.setCurrencyCode(raw.CURRENCY_CODE);
            this.setCpaKey(raw.CPA_KEY);
            this.setDiscountProductGroup(raw.DISCOUNT_PRODUCT_GROUP);
            this.setMeasurementPeriod(raw.MEASUREMENT_PERIOD);
            this.setDiscountPeriod(raw.DISCOUNT_PERIOD);
            this.setThresholdType(raw.THRESHOLD_TYPE);
            this.setDiscountTiersAndValues(raw.DISCOUNT_TIERS_AND_VALUES);
            this.setRampUpPeriod(raw.RAMP_UP_PERIOD);
            this.setRampUpStartDate(raw.RAMP_UP_START_DATE);
            this.setRampUpEndDate(raw.RAMP_UP_END_DATE);
            this.setInitialDiscountPercent(raw.INITIAL_DISCOUNT_PERCENT);
            this.setInitialDiscountPeriod(raw.INITIAL_DISCOUNT_PERIOD);
            this.setCurrentDiscountPercent(raw.CURRENT_DISCOUNT_PERCENT);
            this.setTopDiscountPercent(raw.TOP_DISCOUNT_PERCENT);
            this.setRevenueCount(raw.REVENUE_COUNT);
            this.setProgressCount(raw.PROGRESS_COUNT);
            this.setGapToCurrentLevel(raw.GAP_TO_CURRENT_LEVEL);
            this.setGapToNextLevel(raw.GAP_TO_NEXT_LEVEL);
            this.setNextDiscountStartDate(raw.NEXT_DISCOUNT_START_DATE);
            this.setNextDiscountPercent(raw.NEXT_DISCOUNT_PERCENT);
            this.setFlagProcessed(raw.FLAG_PROCESSED);
            this.setFlagProcessedMarketo(raw.FLAG_PROCESSED_MARKETO);
            this.setEventMonth(raw.EVENT_MONTH);
            this.setDateInserted(raw.DATE_INSERTED);
            this.setDtimeInserted(raw.DTIME_INSERTED);
            this.setDtimeUpdated(raw.DTIME_UPDATED);
        }
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getCode(): string {
        return this.code;
    }

    public setCode(code: string): void {
        this.code = code;
    }

    public getPayerCountry(): string {
        return this.payerCountry;
    }

    public setPayerCountry(payerCountry: string): void {
        this.payerCountry = payerCountry;
    }

    public getCurrencyCode(): string {
        return this.currencyCode;
    }

    public setCurrencyCode(currencyCode: string): void {
        this.currencyCode = currencyCode;
    }

    public getCpaKey(): string {
        return this.cpaKey;
    }

    public setCpaKey(cpaKey: string): void {
        this.cpaKey = cpaKey;
    }

    public getDiscountProductGroup(): string {
        return this.discountProductGroup;
    }

    public setDiscountProductGroup(discountProductGroup: string): void {
        this.discountProductGroup = discountProductGroup;
    }

    public getMeasurementPeriod(): number | null {
        return this.measurementPeriod;
    }

    public setMeasurementPeriod(measurementPeriod: number | null): void {
        this.measurementPeriod = measurementPeriod;
    }

    public getDiscountPeriod(): number | null {
        return this.discountPeriod;
    }

    public setDiscountPeriod(discountPeriod: number | null): void {
        this.discountPeriod = discountPeriod;
    }

    public getThresholdType(): string | null {
        return this.thresholdType;
    }

    public setThresholdType(thresholdType: string | null): void {
        this.thresholdType = thresholdType;
    }

    public getDiscountTiersAndValues(): string | null {
        return this.discountTiersAndValues;
    }

    public setDiscountTiersAndValues(discountTiersAndValues: string | null): void {
        this.discountTiersAndValues = discountTiersAndValues;
    }

    public getRampUpPeriod(): number | null {
        return this.rampUpPeriod;
    }

    public setRampUpPeriod(rampUpPeriod: number | null): void {
        this.rampUpPeriod = rampUpPeriod;
    }

    public getRampUpStartDate(): number | null {
        return this.rampUpStartDate;
    }

    public setRampUpStartDate(rampUpStartDate: number | null): void {
        this.rampUpStartDate = rampUpStartDate;
    }

    public getRampUpEndDate(): number | null {
        return this.rampUpEndDate;
    }

    public setRampUpEndDate(rampUpEndDate: number | null): void {
        this.rampUpEndDate = rampUpEndDate;
    }

    public getInitialDiscountPercent(): number | null {
        return this.initialDiscountPercent;
    }

    public setInitialDiscountPercent(initialDiscountPercent: number | null): void {
        this.initialDiscountPercent = initialDiscountPercent;
    }

    public getInitialDiscountPeriod(): number | null {
        return this.initialDiscountPeriod;
    }

    public setInitialDiscountPeriod(initialDiscountPeriod: number | null): void {
        this.initialDiscountPeriod = initialDiscountPeriod;
    }

    public getCurrentDiscountPercent(): number | null {
        return this.currentDiscountPercent;
    }

    public setCurrentDiscountPercent(currentDiscountPercent: number | null): void {
        this.currentDiscountPercent = currentDiscountPercent;
    }

    public getTopDiscountPercent(): number | null {
        return this.topDiscountPercent;
    }

    public setTopDiscountPercent(topDiscountPercent: number | null): void {
        this.topDiscountPercent = topDiscountPercent;
    }

    public getRevenueCount(): number | null {
        return this.revenueCount;
    }

    public setRevenueCount(revenueCount: number | null): void {
        this.revenueCount = revenueCount;
    }

    public getProgressCount(): number | null {
        return this.progressCount;
    }

    public setProgressCount(progressCount: number | null): void {
        this.progressCount = progressCount;
    }

    public getGapToCurrentLevel(): number | null {
        return this.gapToCurrentLevel;
    }

    public setGapToCurrentLevel(gapToCurrentLevel: number | null): void {
        this.gapToCurrentLevel = gapToCurrentLevel;
    }

    public getGapToNextLevel(): number | null {
        return this.gapToNextLevel;
    }

    public setGapToNextLevel(gapToNextLevel: number | null): void {
        this.gapToNextLevel = gapToNextLevel;
    }

    public getNextDiscountStartDate(): number | null {
        return this.nextDiscountStartDate;
    }

    public setNextDiscountStartDate(nextDiscountStartDate: number | null): void {
        this.nextDiscountStartDate = nextDiscountStartDate;
    }

    public getNextDiscountPercent(): number | null {
        return this.nextDiscountPercent;
    }

    public setNextDiscountPercent(nextDiscountPercent: number | null): void {
        this.nextDiscountPercent = nextDiscountPercent;
    }

    public getFlagProcessed(): string {
        return this.flagProcessed;
    }

    public setFlagProcessed(flagProcessed: string): void {
        this.flagProcessed = flagProcessed;
    }

    public getFlagProcessedMarketo(): string {
        return this.flagProcessedMarketo;
    }

    public setFlagProcessedMarketo(flagProcessedMarketo: string): void {
        this.flagProcessedMarketo = flagProcessedMarketo;
    }

    public getEventMonth(): string {
        return this.eventMonth;
    }

    public setEventMonth(eventMonth: string): void {
        this.eventMonth = eventMonth;
    }

    public getDateInserted(): number {
        return this.dateInserted;
    }

    public setDateInserted(dateInserted: number): void {
        this.dateInserted = dateInserted;
    }

    public getDtimeInserted(): number {
        return this.dtimeInserted;
    }

    public setDtimeInserted(dtimeInserted: number): void {
        this.dtimeInserted = dtimeInserted;
    }

    public getDtimeUpdated(): number {
        return this.dtimeUpdated;
    }

    public setDtimeUpdated(dtimeUpdated: number): void {
        this.dtimeUpdated = dtimeUpdated;
    }

}
